import { RouteType } from "routes/types";
import { lazy } from "react";

const Element = lazy(() => import("./index"));

const route: RouteType = {
  id: 430,
  parentId: 400,
  name: "AccountSettings",
  label: "Account Settings",
  path: "account_settings",
  element: Element,
  user: true,
  nonVerified: true,
  admin: false,
  hidden: false,
};

export default route;
